import { Injectable } from '@angular/core';

import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';


import { AuthService } from '../auth/guard.service';
import { TagParser } from './tag-parser.service';

import { Subscription } from 'rxjs/Subscription';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/toPromise';

export interface Tag {
    display: string,
    normalised: string,
    description: string,
    colour: string,
}

type TagDict = { [normalised: string] : Tag; };

@Injectable()
export class TagService {

    private authSubs : Subscription;
    private tagSubs : Subscription;
    private _tagsFirebaseObs : Observable<AngularFireAction<firebase.database.DataSnapshot>>;
    private _tags = new ReplaySubject<TagDict>(1);
    public tags = this._tags.asObservable();

    constructor(public afDb : AngularFireDatabase, public auth : AuthService, public parser : TagParser) {
        this.subscribeToAll();
    }

    subscribeToAll() {
        this.authSubs = this.auth.user.subscribe(user => {
            if (!user) {
                if (this.tagSubs) {
                    this.tagSubs.unsubscribe();
                    this.tagSubs = null;
                }
                this._tagsFirebaseObs = null;
                this.changeTagsTo({});
            } else {
                this.updateTagsForUser(user);
            }
        });
    }

    changeTagsTo(tags : TagDict) {
        this._tags.next(tags);
    }

    updateTagsForUser(user : firebase.User) {
        let uid = user.uid;

        if (this.tagSubs) {
            this.tagSubs.unsubscribe();
            this.tagSubs = null;
        }

        this._tagsFirebaseObs = this.afDb.object("/tags/"+uid).snapshotChanges();

        this.tagSubs = this._tagsFirebaseObs.subscribe(tags => {
            if (tags.payload.exists()) {
                this.changeTagsTo(tags.payload.val());
            } else {
                this.changeTagsTo({});
            }
        });

    }

    unsubscribeFromAll() {
        if (this.authSubs) {
            this.authSubs.unsubscribe();
            this.authSubs = null;
        }
        if (this.tagSubs) {
            this.tagSubs.unsubscribe();
            this.tagSubs = null;
        }
    }

    parse(text : string) {
        return this.parser.parse(text);
    }

    /**
     * Create a tag if it doesn't exist.
     * @param  {Tag}    tag [description]
     * @return {[type]}     [description]
     */
    createTagIfNotExists(tag : Tag) : Promise<Tag> {
        return this.tags.first().toPromise().then(tags => {
            // if already there just return it
            if (tags.hasOwnProperty(tag.normalised)) {
                return tag;
            }

            return this.auth.user.first().toPromise().then(user => {
                let ref = this.afDb.database.ref("/tags").child(user.uid).child(tag.normalised);
                return ref.update(tag).then(() => tag);
            });

        });
    }


}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/tags/tag.service.ts